import { ICheckPublishTermSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IPublishTermsSchema } from '../../../../repositories/monolith-python/entities/publish_terms/PublishTermsSchema';
import { IPublicationTokens } from '../../../../types/reducers/publishTerms';

interface IParams {
  isAutoprolongChecked: boolean;
  terms: Array<ICheckPublishTermSchema>;
  publicationTokens: IPublicationTokens;
}

export const mapPublishTerms = (params: IParams): IPublishTermsSchema | null => {
  const { isAutoprolongChecked, terms, publicationTokens } = params;

  if (!Array.isArray(terms)) {
    return null;
  }

  return {
    terms,
    autoprolong: isAutoprolongChecked,
    usePromotionFromAuction: false,
    publication: publicationTokens,
  } as unknown as IPublishTermsSchema;
};
